import Box from "@mui/material/Box";
import { observer } from "mobx-react-lite";
import React from "react";
import MultiSelector, { MultiSelectorOptionInterface } from "../../../../components/selectors/MultiSelector";
import i18nStore from "../../../../i18n/store";
import filterStore from "../filters/filtersStore";
import BaseResultTable, { BaseCalculationsTablePropsProps } from "./BaseResultTable";
import useMuiCalculationsDamageParamsColDefs from "./useMuiCalculationsDamageParamsColDefs";
import { ParamType } from "../../enums";


interface ResultDamageParamsTableProps extends BaseCalculationsTablePropsProps {}
const ResultDamageParamsTable = observer((props: ResultDamageParamsTableProps) => {
    const translations = i18nStore.getTranslations;
    const columnDefs = useMuiCalculationsDamageParamsColDefs();

    return (
        <BaseResultTable
            table="damageParams"
            colDefs={columnDefs}
            rows={props.rows}
            loading={props.loading}
            extraToolbar={
                <Box>
                    <MultiSelector
                        values={filterStore.getDamageParamsValueTypes}
                        setValues={(vals) => filterStore.setDamageParamsValueTypes(vals)}
                        options={[
                            {tooltipText: translations.paramType.currents, label: ParamType.Current.name, value: ParamType.Current.name},
                            {tooltipText: translations.paramType.resistances, label: ParamType.Resistance.name, value: ParamType.Resistance.name},
                        ] as MultiSelectorOptionInterface[]}
                    />

                </Box>
            }
        />
    );
});

export default ResultDamageParamsTable;
